import { createContext, ReactNode } from "react";
import * as ReactRouter from "react-router";

export function createParamsProvider(
  ParamsContext: ReturnType<typeof createParamsContext>
) {
  return ({
    path,
    routeName,
    children,
  }: {
    path: string;
    routeName: string;
    children: ReactNode;
  }) => {
    const match = ReactRouter.useRouteMatch(path);

    return (
      <ParamsContext.Provider
        value={{
          routeName,
          params: match ? match.params : null,
        }}
      >
        {children}
      </ParamsContext.Provider>
    );
  };
}

export function createParamsContext() {
  const ParamsContext = createContext<{
    routeName: string;
    params: Record<string, string> | null;
  }>({
    get routeName(): never {
      throw new Error("routeName not provided");
    },
    get params(): never {
      throw new Error("params not provided");
    },
  });

  ParamsContext.displayName = "ParamsProvider";

  return ParamsContext;
}
